import {TypedRedirectProps} from './components'
import {AppRoute} from './types'

export function getRedirectConfig(): TypedObject<AppRoute, TypedRedirectProps> {
  return {
    '/': { to: '/proposal' },
  }
}